import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class AgeRangeService {

    private baseUrl: string = '../rest/company/';

    constructor(private http : Http) {}

    get(companyId:number): any {
        return this.http.get(`${this.baseUrl}${companyId}/agerange`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    loadData(): any{
        return this.http.get(`../rest/data/chargeType`, { headers: this.getHeaders()} )
            .map((response) => response.json());
    }

    create(companyId:number, ageRange): any {
        return this.http.put(`${this.baseUrl}${companyId}/agerange`, ageRange, { headers: this.getHeaders()});
    }

    update(companyId:number, ageRange, oid): any {
        return this.http.put(`${this.baseUrl}${companyId}/agerange/${oid}`, ageRange, { headers: this.getHeaders()});
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/ageRange/age-range.service.ts